import type { SVGProps } from 'react';

const SvgSend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m20.4 11.08-16-7c-.38-.16-.81-.08-1.11.21a1 1 0 0 0-.21 1.1L5.91 12l-2.83 6.61A.997.997 0 0 0 3.99 20c.14 0 .27-.03.4-.08l16-7c.36-.16.6-.52.6-.92s-.24-.76-.6-.92zM5.91 17.07 7.65 13h3.34c.55 0 1-.45 1-1s-.45-1-1-1H7.65L5.91 6.93 17.5 12z"
    />
  </svg>
);
export default SvgSend;
